import { useState, useEffect, useRef } from 'react';
import { getInvoiceDetail, getPracticeInvoiceDetail } from 'api/provider';
import { TInvoiceDetail } from 'types/invoice';

interface Options {
    // Caller fetches explicitly (e.g. only when a modal opens) instead of on every invoiceNo change
    manual?: boolean;
    isPracticeView?: boolean;
}

const useInvoiceDetail = (
    invoiceNo: string,
    { manual, isPracticeView }: Options = {},
): [TInvoiceDetail | undefined, boolean, (invoiceNo: string) => void] => {
    const [data, setData] = useState<TInvoiceDetail>();
    const [loading, setLoading] = useState<boolean>(false);
    const lastInvoiceNo = useRef<string>();

    const fetchData = async (invoiceNo: string) => {
        // Don't show the previous invoice while a different one loads
        if (lastInvoiceNo.current !== invoiceNo) {
            setData(undefined);
            lastInvoiceNo.current = invoiceNo;
        }
        try {
            setLoading(true);
            const request = isPracticeView ? getPracticeInvoiceDetail : getInvoiceDetail;
            const res = await request(invoiceNo);
            if (!res.error) {
                const data = res.data?.data;
                if (data) {
                    setData(data);
                }
            }
        } catch (err) {
            console.error('Invoice detail fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (invoiceNo && !manual) {
            fetchData(invoiceNo);
        }
    }, [invoiceNo]);

    return [data, loading, fetchData];
};

export default useInvoiceDetail;
